import React, { useState, useEffect } from "react";
import "../../Css/SalesDashboard.css";

export default function SpSalesDashboard() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const data = [
    {
      title: "Sales & Inventory Tracking",
      text: "Gain quick insight into your sales performance with key indicators like available units, interested leads, booked units, and units with payments pending.",
      img: "/images/SuperBuild-Sales-Feature1.png",
    },
    {
      title: "Financial Clarity",
      text: "View total sales revenue analytics as well as a breakdown of all payments with their gateway status (RTGS, NEFT, Cheque, Cash, and others).",
      img: "/images/SuperBuild-Sales-Feature2.png",
    },
    {
      title: "Customer & Lead Insights",
      text: "View a list of recent interested leads and new customers. All information is displayed in a single location using clear lists and graphs.",
      img: "/images/SuperBuild-Sales-Feature3.png",
    },
  ];

  return (
    <div
      className="position-relative px-6 bg-F7F8FA py-5"
      style={{ zIndex: "9" }}
    >
      <h2 className="super-buildup-sales-dashboard-title">SALES DASHBOARD</h2>

      <div className="super-buildup-sales-dashboard-timeline">
        {!isMobile &&
          data.map((item, index) => (
            <div
              className={`row super-buildup-sales-dashboard-row ${
                index % 2 !== 0
                  ? "justify-content-start"
                  : "justify-content-end"
              }`}
              key={index}
            >
              {/* LEFT SIDE (odd items) */}
              {index % 2 !== 0 && (
                <div className="col-md-5 px-0 super-buildup-sales-dashboard-content text-end">
                  <h5 className="super-buildup-sales-dashboard-heading">
                    {item.title}
                  </h5>
                  <p className="super-buildup-sales-dashboard-text">
                    {item.text}
                  </p>
                  <div className="super-buildup-sales-dashboard-img-wrapper">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="super-buildup-sales-dashboard-img"
                    />
                  </div>
                </div>
              )}

              {/* CENTER LINE + DOT */}
              <div className="col-md-2 px-0 super-buildup-sales-dashboard-center">
                <div className="super-buildup-sales-dashboard-dot"></div>
              </div>

              {/* RIGHT SIDE (even items) */}
              {index % 2 === 0 && (
                <div className="col-md-5 px-0 super-buildup-sales-dashboard-content">
                  <h5 className="super-buildup-sales-dashboard-heading">
                    {item.title}
                  </h5>
                  <p className="super-buildup-sales-dashboard-text">
                    {item.text}
                  </p>
                  <div className="super-buildup-sales-dashboard-img-wrapper">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="super-buildup-sales-dashboard-img"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}

        {isMobile &&
          data.map((item, index) => (
            <div
              className="super-buildup-sales-dashboard-mobile-row"
              key={index}
            >
              <div className="super-buildup-sales-dashboard-mobile-left">
                <div className="super-buildup-sales-dashboard-dot"></div>
              </div>
              <div className="super-buildup-sales-dashboard-mobile-content">
                <h5 className="super-buildup-sales-dashboard-heading">
                  {item.title}
                </h5>
                <p className="super-buildup-sales-dashboard-text">
                  {item.text}
                </p>
                <div className="super-buildup-sales-dashboard-img-wrapper">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="super-buildup-sales-dashboard-img"
                  />
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
